export default __webpack_public_path__ + "static/media/resnetgru6.652db087.png";